import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Documentation / guide — livre ouvert duotone */
export const BookIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Page droite menthe */}
      <path d="M12 6c2-1.5 4.5-2 8-2v14c-3.5 0-6 .5-8 2V6z" fill="var(--equiply-icon-bg)" fillOpacity="0.5" />
      {/* Livre ouvert (contour) */}
      <path
        d="M12 6c-2-1.5-4.5-2-8-2v14c3.5 0 6 .5 8 2 2-1.5 4.5-2 8-2V4c-3.5 0-6 .5-8 2z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Reliure centrale */}
      <path d="M12 6v14" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Petites lignes texte */}
      <path d="M6 8h3M6 11h3M15 8h3M15 11h3" stroke="var(--equiply-icon-fg)" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  ),
);
BookIcon.displayName = "BookIcon";
